import { render, staticRenderFns } from "./ChooseBranch.vue?vue&type=template&id=3700f89a&scoped=true&"
import script from "./ChooseBranch.vue?vue&type=script&lang=js&"
export * from "./ChooseBranch.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBranch.vue?vue&type=style&index=0&id=3700f89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3700f89a",
  null
  
)

export default component.exports